import { Button } from "@base/ui/Button/Button";
import { Dialog } from "@base/ui/Dialog";
import { hideSilverTourForToday } from "@features/membership/lib/utils";
import { useTranslation } from "react-i18next";

const TOUR_BOOKING_URL = "https://calendly.com/82office-buildblock/30min";

type Props = {
  isOpen: boolean;
  onClose: () => void;
};

export function SilverTourDialog({ isOpen, onClose }: Props) {
  const { t } = useTranslation();

  const handleHideForToday = () => {
    hideSilverTourForToday();
    onClose();
  };

  return (
    <Dialog open={isOpen} onClose={onClose}>
      <Dialog.Content className="w-[calc(100vw-32px)] min-w-0 max-w-[336px] p-4">
        <div className="flex flex-col flex-1 gap-y-2 items-center min-h-0">
          <div className="px-[53px] py-[85px]">
            <img
              src="/assets/82Office_Logo.svg"
              alt=""
              className="h-[129px] w-[198px] shrink-0 object-cover"
              aria-hidden="true"
            />
          </div>

          <div className="flex flex-col gap-2 items-center mt-2 text-center">
            <Dialog.Title className="font-semibold text-label1">{t("silverTourTitle")}</Dialog.Title>
            <Dialog.Description className="whitespace-pre-line text-xs leading-[1.5] tracking-[-0.24px] text-gray-900">
              {t("silverTourDescription")}
            </Dialog.Description>
          </div>
        </div>

        <Button asChild className="mt-6 w-full shrink-0">
          <a href={TOUR_BOOKING_URL} target="_blank" rel="noopener noreferrer">
            {t("silverTourCta")}
          </a>
        </Button>
        <Button variant="ghost" color="secondary" className="mt-2 w-full shrink-0" onClick={handleHideForToday}>
          {t("silverTourHideForToday")}
        </Button>
      </Dialog.Content>
    </Dialog>
  );
}
